export default class DtoTerritoryEmissionsDeclaration {
    constructor(obj) {
        this.year = obj.year // Int
        this.environment = obj.environment // String
        this.pollutant = obj.pollutant // String
        this.quantity = obj.quantity // Float
        this.unit = obj.unit // String
    }
}